export default __webpack_public_path__ + "static/media/about-team-lu-truong.b091a2a0.png";